import React from "react";
import { Table } from "./Table";

const Menus = () => {
  return <Table />;
};

export default Menus;
